import yup from "src/validators/yup.Module";

export type FormType = yup.InferType<typeof schema>;

// Meios que exigem TipoIntegracao: 3 = Cartão Crédito, 4 = Cartão Débito, 17 = PIX.
export const MEIOS_PAGAMENTO_COM_INTEGRACAO = [3, 4, 17];
// 2 = Não integrado com sistema de automação (não há integração).
export const TIPO_INTEGRACAO_NAO_INTEGRADO = 2;

export const getTipoIntegracao = (meioPagamento?: number | null) =>
  meioPagamento != null && MEIOS_PAGAMENTO_COM_INTEGRACAO.includes(meioPagamento)
    ? TIPO_INTEGRACAO_NAO_INTEGRADO
    : null;

export const schema = yup.object({
  dadosParcelas: yup.array().of(
    yup.object({
      meioPagamento: yup
        .number()
        .typeError("Selecione o meio de pagamento")
        .required("Selecione o meio de pagamento"),

      valorPagamento: yup
        .number()
        .required("Informe o valor")
        .typeError("Informe o valor válido")
        .when("meioPagamento", {
          is: (meioPagamento: number) => meioPagamento === 90,
          then: (schema) =>
            schema.test(
              "valor-zero",
              "Sem meio pagamento, informe zero",
              (value) => value === 0
            ),
          otherwise: (schema) =>
            schema
              .required("Informe o valor")
              .moreThan(0, "Valor deve ser maior que zero"),
        }),

      // Definido automaticamente (fixo em 2) a partir do meio de pagamento.
      tipoIntegracao: yup.number().nullable().notRequired(),

      descricaoMeioPagamento: yup
        .string()
        .nullable()
        .when("meioPagamento", {
          is: (meioPagamento: number) => meioPagamento === 99,
          then: (schema) =>
            schema.required("Descrição é obrigatório para pagamento 'outros'"),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),
    })
  ),
  totalPagamentos: yup.string(),
  diferencaPagamentos: yup.string(),
});
